/* LB (Lotte 2out26, Nuala 5out26): nao deixa comprar sem tamanho escolhido.
   O product-variant-options.liquid deixou de marcar o tamanho (vinha XS pre-escolhido),
   mas o formulario da Shopify continua com a 1.a variante no campo "id". Sem este travao
   um toque no botao metia XS no carrinho. Com ?variant= no URL (Google Shopping) o
   tamanho vem marcado e isto nao faz nada. */
(function(){
  'use strict';
  var AVISO = 'Select a size';
  var RE = /größe|grösse|groesse|grosse|size/i;

  function camposTamanho(){
    var out = [];
    document.querySelectorAll('[data-variant-buttons]').forEach(function(box){
      var fs = box.closest('fieldset') || box.parentElement;
      var leg = fs && fs.querySelector('legend');
      if (leg && RE.test(leg.textContent || '') && box.querySelector('input[type=radio]')) out.push(box);
    });
    return out;
  }
  function falta(){
    return camposTamanho().some(function(box){ return !box.querySelector('input[type=radio]:checked'); });
  }
  function botoes(){
    return document.querySelectorAll('form[action*="/cart/add"] button[name=add], #cart-bar button[data-add-to-cart-bar], [data-add-to-cart-bar]');
  }
  function aviso(mostrar){
    camposTamanho().forEach(function(box){
      var m = box.parentElement.querySelector('.lb-tam-aviso');
      if (mostrar && !m) {
        m = document.createElement('p'); m.className = 'lb-tam-aviso'; m.textContent = AVISO + '.';
        box.insertAdjacentElement('afterend', m);
      } else if (!mostrar && m) m.remove();
      if (mostrar) { box.classList.remove('lb-tam-abana'); void box.offsetWidth; box.classList.add('lb-tam-abana'); }
    });
  }
  function pintar(){
    var f = falta();
    botoes().forEach(function(b){
      var alvo = b.querySelector('.btn__text') || b;
      if (f) {
        if (!b.hasAttribute('data-lb-original')) b.setAttribute('data-lb-original', alvo.innerHTML);
        if (alvo.textContent.trim() !== AVISO) alvo.textContent = AVISO;
        b.removeAttribute('disabled');
      } else if (b.hasAttribute('data-lb-original')) {
        alvo.innerHTML = b.getAttribute('data-lb-original');
        b.removeAttribute('data-lb-original');
      }
    });
    if (!f) aviso(false);
  }
  function travar(e){
    if (!falta()) return;
    var b = e.target && e.target.closest && e.target.closest('button[name=add], [data-add-to-cart-bar]');
    if (e.type === 'submit' || b) {
      e.preventDefault(); e.stopImmediatePropagation();
      aviso(true);
      var box = camposTamanho()[0];
      if (box) box.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
  }
  function arrancar(){
    if (!camposTamanho().length) return;
    var css = document.createElement('style');
    css.textContent = '.lb-tam-aviso{color:#c0392b;font-size:14px;font-weight:600;margin:8px 0 0}'
      + '@keyframes lbTamAbana{0%,100%{transform:none}20%,60%{transform:translateX(-6px)}40%,80%{transform:translateX(6px)}}'
      + '.lb-tam-abana{animation:lbTamAbana .4s}';
    document.head.appendChild(css);
    pintar();
    document.addEventListener('click', travar, true);
    document.addEventListener('submit', travar, true);
    document.addEventListener('change', function(e){ if (e.target && e.target.type === 'radio') setTimeout(pintar, 80); }, true);
    // o product.js do tema reescreve o botao depois de arrancar; repintar quando mexer
    botoes().forEach(function(b){ new MutationObserver(function(){ if (falta()) pintar(); }).observe(b, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled']}); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
})();
